import { Component } from '@angular/core';

@Component({
  selector: 'app-loading-indicator-full',
  templateUrl: './loading-indicator-full.component.html',
  styleUrls: ['./loading-indicator-full.component.scss'],
})
export class LoadingIndicatorFullComponent {}
